module.exports = __webpack_public_path__ + "media/views/builder/sites/assets/checkbox_unchecked-79adfefa113db425913c6d4739326e5d.svg";